// extracted by mini-css-extract-plugin
module.exports = {"customer-name":"CustomerName_customer-name__WcFhl","icon":"CustomerName_icon__BXnS2","name":"CustomerName_name__fNSQM"};